import { Autocomplete, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Input, InputLabel, Link, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import APIManager from '../../lib/apiManager';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { Stack } from '@mui/material';
import { sistema } from '../../model/Sistema';

const Miembro = ({setBotonera, espacios}) => {

  const [loading, setLoading] = useState(true);

  const [active, setActive] = useState(false);
  const [registroCompleto, setRegistroCompleto] = useState(false);
  const [aceptado, setAceptado] = useState(false);
  const [esStaff, setEsStaff] = useState(false);

  const [miembro, setMiembro] = useState(false);
  const [empresa, setEmpresa] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [cargo, setCargo] = useState('');

  const [profesion, setProfesion] = useState(null);
  const [profesiones, setProfesiones] = useState([]);

  const [editando, setEditando] = useState(false);
  const [laboralChangeOpen, setLaboralChangeOpen] = useState(false);

  const [espacio, setEspacio] = useState('');

  const [nombres, setNombres] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [emailDeContacto, setEmailDeContacto] = useState('');
  const [email, setEmail] = useState('');

  const [fechaDeIngreso, setFechaDeIngreso] = useState('');

  const tiposDeMiembro = ['FREELANCER','EMPLEADO'];
  const [tipoDeMiembro, setTipoDeMiembro] = useState('');

  const [habilitadoParaGuardar, setHabilitadoParaGuardar] = useState(false);

  let { usuarioId } = useParams();

  const botoneraDeMiembro = [
    { title: 'Volver', label: 'Volver', variant: 'outlined', onClick: () => { navigate(-1); } },
    { title: 'Editar', label: 'Editar', variant: (editando ? 'outlined' : 'contained'), visible: !editando, onClick: () => { setEditando(!editando); setHabilitadoParaGuardar(false)} },
    { title: 'Guardar', label: 'Guardar', variant: 'contained', visible: editando, disabled: !habilitadoParaGuardar, onClick: () => { handleGuardar(); } },
    { title: 'Cancelar', label: 'Cancelar', variant: 'contained', visible: editando, onClick: () => { handleCancelar(); } },
  ];

  const navigate = useNavigate();

  const editarMiembro = () => {
    setEditando(!editando);
  }

  const cargarProfesiones = () => {
    APIManager.getList('profesiones', {orderBy: 'descripcion'}, (response) => {
      if (response.success) {
        setProfesiones(response.data.listado);
      }
    });
  }

  const cargarEmpresas = () => {
    APIManager.getList('empresas', {active: true}, (response) => {
      if (response.success) {
        setEmpresas(response.data.listado);
      }
    });
  }

  const miembroActualizado = () => {
    const miembroActualizado = { ...miembro, nombres: nombres, apellidos: apellidos };
    miembroActualizado.activo = active;
    miembroActualizado.is_accepted = aceptado;
    miembroActualizado.is_registration_completed = registroCompleto;
    miembroActualizado.is_staff = esStaff;
    miembroActualizado.nombres = nombres;
    miembroActualizado.apellidos = apellidos;
    miembroActualizado.email = email.toLowerCase().trim();
    setEmail(miembroActualizado.email);
    miembroActualizado.nombre = email.toLowerCase().trim();
    miembroActualizado.contact_email = emailDeContacto.toLowerCase().trim();
    setEmailDeContacto(miembroActualizado.contact_email);
    miembroActualizado.relacionLaboral = null;
    miembroActualizado.tipo = tipoDeMiembro;
    miembroActualizado.profesion = profesion;
    miembroActualizado.empresa = empresa;
    miembroActualizado.cargo = cargo;
    miembroActualizado.espacio = espacio;
    miembroActualizado.mqco_joining_date = fechaDeIngreso;

    return miembroActualizado;

  }

  const guardarMiembro = () => {
    const miembroAEnviar = miembroActualizado();

    APIManager.sendRequest('post', 'usuario', 'modificarUsuario', { usuario: miembroAEnviar }, (response) => {
      if (response.success) {
        setEditando(false); // Se guardó y ya no estamos editando
        setMiembro(null);
        actualizarMiembro(response.data.usuario.id);
        setHabilitadoParaGuardar(false);
      }
    });

  }

  const handleActive = (event) => {
    setActive(event.target.checked);
    setHabilitadoParaGuardar(true);
  }

  const handleRegistroCompleto = (event) => {
    setRegistroCompleto(event.target.checked);
    setHabilitadoParaGuardar(true);
  }

  const handleEsStaff = (event) => {
    setEsStaff(event.target.checked);
    setHabilitadoParaGuardar(true);
  }

  const handleEspacio = (espacioActual) => {
    setEspacio(espacioActual);
    setHabilitadoParaGuardar(true);
  }

  const handleNombres = (event) => {
    setNombres(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleApellidos = (event) => {
    setApellidos(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleEmail = (event) => {
    setEmail(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleEmailDeContacto = (event) => {
    setEmailDeContacto(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleFechaDeIngreso = (event) => {
    setFechaDeIngreso(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleEmpresa = (event, item) => {
    setEmpresa(item);
    setHabilitadoParaGuardar(true);
  }

  const handleCargo = (event) => {
    setCargo(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleGuardar = (event) => {
    guardarMiembro();
  }

  const handleCancelar = (event) => {
    setEditando(false);
    setMiembro(null);
    setLoading(true);
    actualizarMiembro(usuarioId);
  }

  const handleTipoDeMiembro = (event) => {
    setTipoDeMiembro(event.target.value);
    setHabilitadoParaGuardar(true);
    if (!!miembro?.relacionLaboral) {
      setLaboralChangeOpen(true);
    }
  }

  const handleCancelarTipo = () => {
    setTipoDeMiembro(miembro.relacionLaboral.tipo);
    setLaboralChangeOpen(false);
  }

  const handleProfesion = (event, item) => {
    setProfesion(item);
    setHabilitadoParaGuardar(true);
  }

  const actualizarMiembro = (usuarioId) => {
    setLoading(true);
    if (!!usuarioId) {
      APIManager.sendRequest('post', 'usuario', 'getUsuario', {usuarioID: usuarioId}, (response) => {
        if (response.success) {
          setMiembro(response.data.usuario);
        }
      })
    }
  }

  useEffect(() => {
    actualizarMiembro(usuarioId);
  }, [usuarioId]);

  useEffect(() => {
    if (!!miembro && (espacios.length > 0) && (profesiones.length > 0)) {
      setNombres(miembro.nombres);
      setApellidos(miembro.apellidos);
      setEmail(miembro.email);
      setEmailDeContacto(miembro.contact_email);
      setActive(miembro.activo);
      setAceptado(miembro.is_accepted);
      setRegistroCompleto(miembro.is_registration_completed);
      setEsStaff(miembro.is_staff);
      setTipoDeMiembro(miembro.relacionLaboral?.tipo ?? '');
      setFechaDeIngreso(miembro.mqco_joining_date ?? miembro.date_joined);
      const nuevoEspacio = espacios.find((item) => {
        if (!!miembro.espacio) {
          return item.id === miembro.espacio.id;
        } else {
          return item.id === sistema.espacio.id;
        }
      });
      setEspacio(nuevoEspacio);
      setEmpresa(miembro?.relacionLaboral?.empresa ?? null);
      setCargo(miembro?.relacionLaboral?.cargo ?? '');
      setProfesion((profesiones.length > 0) ? profesiones.find(item => item.id == miembro?.profesion?.id) : (miembro?.profesion ?? null));
      setLoading(false);
    }
   }, [miembro, espacios, profesiones]);

  useEffect(() => {
    // Hubo actualizacion
    setBotonera(botoneraDeMiembro);
    }, [habilitadoParaGuardar, active, editando, espacio, nombres, apellidos, email, emailDeContacto, profesion, empresa, esStaff, registroCompleto, aceptado, fechaDeIngreso, cargo]);
  // });

  useEffect(() => {
    cargarProfesiones();
    cargarEmpresas();
  }, []);

  return (
    <Paper sx={{ padding: '14px' }}>
      <Dialog open={laboralChangeOpen} >
        <DialogTitle>Cambio de relación laboral</DialogTitle>
        <DialogContentText>Si cambia el tipo de relación laboral, se verá afectado el contrato actual del miembro.</DialogContentText>
        <DialogActions><Button onClick={() => setLaboralChangeOpen(false)}>Aceptar</Button><Button onClick={handleCancelarTipo}>Cancelar</Button></DialogActions>
      </Dialog>
      {!!miembro
        ? <Grid container spacing={2}>
          <Grid item xs={12}><Typography>Identificación</Typography></Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth variant="standard" required
              label="Usuario / Email de login"
              type="email"
              disabled={!editando}
              value={email}
              onChange={handleEmail}
            />
          </Grid>
          <Grid item xs={12} sm={1} >
            <FormLabel disabled={!editando} component="legend" sx={{transform: "scale(0.75)"}}>Completo</FormLabel>
            <Checkbox disabled={!editando} checked={registroCompleto} onChange={handleRegistroCompleto} />
          </Grid>
          <Grid item xs={12} sm={1} >
            <FormLabel disabled={true} component="legend" sx={{transform: "scale(0.75)"}}>Aceptado</FormLabel>
            <Checkbox disabled={true} checked={aceptado} title="Aceptado" />
          </Grid>
          <Grid item xs={12} sm={1} >
              <FormLabel disabled={!editando} component="legend" sx={{transform: "scale(0.75)"}}>MQ Staff</FormLabel>
              <Checkbox disabled={!editando} checked={esStaff} onChange={handleEsStaff} />
          </Grid>
          <Grid item xs={12} sm={1} >
              <FormLabel disabled={!editando} component="legend" sx={{transform: "scale(0.75)"}}>Activo</FormLabel>
              <Checkbox disabled={!editando} checked={active} onChange={handleActive} />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField fullWidth variant="standard"
              label="ID"
              disabled={true}
              value={(!!miembro && !!miembro.id) ? miembro.id : ''}
            />
          </Grid>
          <Grid item xs={12}><Typography>Datos personales</Typography></Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth variant="standard" required
              label="Nombres"
              disabled={!editando}
              value={nombres}
              onChange={handleNombres}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
          <TextField fullWidth variant="standard" required
              label="Apellidos"
              disabled={!editando}
              value={apellidos}
              onChange={handleApellidos}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth variant="standard" required
              label="Fecha de ingreso"
              type="date"
              disabled={!editando}
              value={fechaDeIngreso}
              onChange={handleFechaDeIngreso}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField fullWidth variant="standard" required
              label="Email de contacto"
              type="email"
              disabled={!editando}
              value={emailDeContacto}
              onChange={handleEmailDeContacto}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="espacio-select"
              value={espacio}
              onChange={(e,item) => handleEspacio(item)}
              fullWidth
              disabled={!editando}
              options={espacios}
              getOptionLabel={item => item?.nombre ?? ''}
              isOptionEqualToValue={(option, value) => value?.id == option?.id}
              renderInput={(params) =>
                <TextField required variant="standard" {...params} label="Espacio preferido" />
              }
              title={espacio?.nombre ?? ''}
            />
          </Grid>
          <Grid item xs={12}><Typography>Datos laborales</Typography></Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="profesion-select"
              value={profesion}
              onChange={handleProfesion}
              fullWidth
              disabled={!editando}
              options={profesiones}
              getOptionLabel={item => item?.descripcion ?? ''}
              isOptionEqualToValue={(option, value) => value?.id == option?.id}
              renderInput={(params) =>
                <TextField variant="standard" {...params} label="Profesión" />
              }
              title={profesion?.nombre ?? ''}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl variant="standard" fullWidth disabled={!editando}>
              <InputLabel required id="tipoDeMiembro-label" shrink={true} >Tipo</InputLabel>
              <Select
                labelId="tipoDeMiembro-label"
                id="tipoDeMiembro-select"
                value={tipoDeMiembro}
                onChange={handleTipoDeMiembro}
                label="Tipo de Miembro"
                disabled={!editando}
                fullWidth
              >
                {tiposDeMiembro.map(
                  (tipo => <MenuItem value={tipo}>{tipo}</MenuItem>)
                )}
              </Select>
            </FormControl>
          </Grid>
          {(tipoDeMiembro === 'EMPLEADO') && <>
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="profesion-select"
                value={empresa}
                onChange={handleEmpresa}
                fullWidth
                disabled={!editando}
                options={empresas}
                getOptionLabel={item => item?.nombre ?? ''}
                renderInput={(params) =>
                  <TextField variant="standard" required {...params} label="Empresa" />
                }
                title={empresa?.nombre ?? ''}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField variant="standard" fullWidth required
                label="Cargo"
                value={cargo}
                onChange={handleCargo}
                disabled={!editando}
              />
            </Grid>
          </>}
        </Grid>
        : (loading
          ? <Grid item xs={12}><Stack height="50vh" direction="row" justifyContent="center" alignItems="center"><CircularProgress /></Stack></Grid>
          : <> { 'No hay datos del miembro' }</>)
      }
    </Paper>
  )
}

export default Miembro;